import { Icon, Reveal } from '@nexa/ui';

interface Capability {
  readonly icon: 'infinity' | 'user-plus';
  readonly title: string;
  readonly body: string;
}

export interface CapabilityCardsProps {
  readonly capabilities: readonly Capability[];
}

/**
 * Hai card năng lực — `template.html:919-927`.
 *
 * Khác `AgentTypeCards` ở 7 thuộc tính, và một trong số đó dễ bỏ sót: `data-reveal` ở thiết kế
 * nằm trên LƯỚI (:919), không trên từng card. Nên ở đây `Reveal` bọc lưới, và trong lưới không
 * có `Reveal` nào.
 *
 * Khối này KHÔNG có hover — thiết kế chỉ khai `style-hover` cho card 3 và card 6, không cho card
 * 2 (so :905 với :920). Đừng thêm cho "nhất quán".
 */
export function CapabilityCards({ capabilities }: CapabilityCardsProps) {
  return (
    <Reveal className="mt-4 grid gap-4 xl:grid-cols-2">
      {capabilities.map((item) => (
        <div
          key={item.title}
          className="h-full rounded-card border border-[var(--on-dark-line-20)] bg-[var(--on-dark-fill-05)] p-6"
        >
          <div className="flex items-center gap-2.5">
            <Icon name={item.icon} size={19} className="text-accent" />
            <span className="text-title font-bold text-white">{item.title}</span>
          </div>
          <p className="mt-[11px] text-body text-[var(--on-dark-text-70)]">{item.body}</p>
        </div>
      ))}
    </Reveal>
  );
}
